/**
 * Generate a secure random token for user access
 * @param length - Length of the token (default 32)
 * @returns A secure random token
 */
export function generateAccessToken(length: number = 32): string {
  const array = new Uint8Array(length);
  crypto.getRandomValues(array);
  return Array.from(array, byte => byte.toString(16).padStart(2, '0')).join('');
}

/**
 * Validate token format
 * @param token - Token to validate
 * @returns True if token is valid format
 */
export function isValidTokenFormat(token: string): boolean {
  // Token should be 64 hex characters (32 bytes)
  return /^[a-f0-9]{64}$/i.test(token);
}

/**
 * Generate a secure link with token for user to update their data
 * @param token - User's access token
 * @param baseUrl - Base URL of the application
 * @returns Full URL with token
 */
export function generateUpdateLink(token: string, baseUrl: string = window.location.origin): string {
  return `${baseUrl}?token=${token}`;
}

/**
 * Extract token from URL query parameters
 * @returns Token if found, null otherwise
 */
export function getTokenFromUrl(): string | null {
  const params = new URLSearchParams(window.location.search);
  return params.get('token');
}

